import { Injectable } from '@angular/core';
import { ApiConstants } from '../../../shared/constants/api-constants';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EmployeeDetails } from '../models/employee-details';
import { UserTrainingPlanDTO } from '../../user-training-plan/models/user-training-plan';
import { TrainingPlanBulkActionRequest } from '../models/training-plan-bulk-action-request';
import { EmployeesTrainingPlanDetails } from '../models/employeeTrainingPlanDetails';
import { SharedConstants } from '../../../shared/constants/shared-constants';
import { ContentTypeEnum, ExportRequest, FormatTypeEnum } from '../models/export';
import { MessageService } from 'primeng/api';
import { TrainingPlanDetailsDto } from '../../user-training-plan/models/trainingPlanDetailsDto';
import { NameCode } from '../../../shared/models/name-code';

@Injectable({
  providedIn: 'root'
})
export class EmployeesTrainingPlanService {
  fileData: any;
  exportRequest: any;

  constructor(private httpClient: HttpClient, private messageService: MessageService) { }

  getOutstandingReviewReportData(exportDTO: ExportRequest): Observable<any> {
    return this.httpClient.post<ExportRequest>(
      ApiConstants.Training_Export_Api, exportDTO);
  }

  exportOutstandingReviewReport(puid: string) {
    this.exportRequest = new ExportRequest();
    var requestData: {[key: string]: string} = {
      'puid': puid
  }
    this.exportRequest.ContentType = ContentTypeEnum.TrainingPlanReview;
    this.exportRequest.FormatType = FormatTypeEnum.excel;
    this.exportRequest.SearchCriteria = requestData;
    this.getOutstandingReviewReportData(this.exportRequest).subscribe((data) => {
      this.fileData = data;
      let byteData = this.fileData;
      if(byteData.excelInBytes != "") {
        const byteCharacters = atob(byteData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], { type: 'application / vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      var fileName = SharedConstants.Outstanding_Review_Report_FileName.replace("{puid}", puid)
                                        .replace("{date}", this.date_TO_String(new Date()));
      anchor.download = fileName;
      anchor.href = url;
      anchor.click();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'You don\'t have any user with pending Training Plan Review.',
        });
      }      
    });
  }

  date_TO_String(date_Object: Date): string {
    // get the year, month, date, hours, and minutes seprately and append to the string.
    let date_String: string =
      date_Object.getFullYear() +
      "_" +
      (date_Object.getMonth() + 1) +
      "_" +
      +date_Object.getDate();
    return date_String;
  }

  getEmployeeDetailsForManager(managerPuid: string): Observable<EmployeeDetails[]> {
    const apiUrl = `${ApiConstants.GetEmployeeDetailsForManagerPuid_Api}?managerPuid=${managerPuid}`;
    return this.httpClient.get<EmployeeDetails[]>(apiUrl);
  }

  addTrainingPlanReviewWithStatusCompleted(puid: string, comment: string): Observable<any> {
    const requestBody = {
      puid: puid,
      comment: comment,
    };
    const apiUrl = `${ApiConstants.AddTrainingPlanReviewWithStatusCompleted_API}`;
    return this.httpClient.put<any>(apiUrl, requestBody);
  }


  getEmployeeTrainingPlan(puid?: string): Observable<TrainingPlanDetailsDto> {
    let params = new HttpParams();
    if (puid) {
      params = params.set('puid', puid);
    }
    return this.httpClient.get<TrainingPlanDetailsDto>(ApiConstants.GetUserTrainingPlan_Api, { params });
  }

  private employeeTrainingItemsSubject = new BehaviorSubject<UserTrainingPlanDTO[]>([]);
  public employeeTrainingItems$ = this.employeeTrainingItemsSubject.asObservable();

  private progressKPISubject = new BehaviorSubject<any | null>(null);
  public progressKPI$ = this.progressKPISubject.asObservable();

  updateTrainingItems(trainingItems: UserTrainingPlanDTO[]): void {
    this.employeeTrainingItemsSubject.next(trainingItems);
  }

  updateProgressKPI(progressKPI: any): void {
    this.progressKPISubject.next(progressKPI);
  }

  updateTrainingPlanCoreOrElective(request: TrainingPlanBulkActionRequest): Observable<any> {
    return this.httpClient.put(ApiConstants.updateTrainingPlanCoreOrElective_Api, request);
  }
  updateTrainingPlanStatus(request: TrainingPlanBulkActionRequest): Observable<any> {
    return this.httpClient.put(ApiConstants.updateTrainingPlanStatus_Api, request);
  }
  updateTrainingPlanTrainingStatus(request: TrainingPlanBulkActionRequest): Observable<any> {
    return this.httpClient.put(ApiConstants.updateTrainingPlanTrainingStatus_Api, request);
  }
  getLatestDocumentDetail(documentNumberList: string[]): Observable<any> {
    return this.httpClient.post(ApiConstants.Get_List_Of_DocumentLatestVersion_Api, documentNumberList);
  }

  getSelectedUserScopes(puid: string): Observable<any> {
    return this.httpClient.get(ApiConstants.GetSelectedUserScopes_Api.replace("{puid}", puid));
  }

  updateTrainingPlanForSelectedUser(employeesTrainingPlanDetails: EmployeesTrainingPlanDetails): Observable<any> {
    return this.httpClient.put(ApiConstants.TrainingPlanUpdate_ForEmployee_Api, employeesTrainingPlanDetails);
  }

  getTrainingItemGroupsFromTrainingPlan(puid: string): Observable<NameCode[]> {
    return this.httpClient.get<NameCode[]>(ApiConstants.GetTrainingItemGroupFromTrainingPlan_Api.replace('{puid}', puid));
  }

  unAssignTrainingItemGroupsFromTrainingPlan(puid: string, trainingItemGroupCodes: string[]): Observable<any> {
      return this.httpClient.put(ApiConstants.UnAssignTrainingItemGroupsForTrainingPlan_Api.replace('{puid}', puid), trainingItemGroupCodes);
  }

}
